import { t } from 'i18next';
import { RouteObject } from 'react-router-dom';
import { AdditionalDeputatePage } from './Deputate/AdditionalDeputatePage';
import { DeputatePlanPage } from './DeputatePlanPage';
import { LessonsPage } from './Lesson/LessonsPage';
import { lessonRoutes } from './Lesson/routes';

export const deputatePlanRoutes = (baseSlug: string): RouteObject[] => {
  return [
    {
      index: true,
      element: <DeputatePlanPage />,
    },

    {
      path: t('routes.lessons.slug'),
      element: <LessonsPage />,
      handle: {
        crumb: () => ({
          slug: `${baseSlug}/${t('routes.lessons.slug')}`,
          title: t('routes.lessons.title'),
        }),
      },
      children: [...lessonRoutes(baseSlug)],
    },

    {
      path: t('routes.deputate.additional.slug'),
      element: <AdditionalDeputatePage />,
      handle: {
        crumb: () => ({
          slug: `${baseSlug}/${t('routes.deputate.additional.slug')}`,
          title: t('routes.deputate.additional.title'),
        }),
      },
    },
  ];
};
